





























































import { Component, Prop, Vue } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from "@/definitions";

import { Layer } from "@/model/document2/page/surface/design/layer/layer";
import { SpecialPatternLayer } from "@/model/document2/page/surface/design/layer/specialPatternLayer";

import { ColorConstruct } from "@/utilityModels/colorConstruct";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    AdjustedBalloon,
    ArrowDown,
    ArrowRight,
    CheckBoxOn
  }
})
export default class SpecialPatternStyle extends Vue {
    @Prop() private layer!: SpecialPatternLayer;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend: true
    };

    specialPatternStyleContentsOpenAnimate = false;
    specialPatternStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.specialPatternStyleContentsCloseAnimate = true;
            setTimeout(() => {
                this.specialPatternStyleContentsCloseAnimate = false;
                this.specialPatternStyleContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.specialPatternStyleContentsOpenAnimate = true;
            setTimeout(() => {
                this.specialPatternStyleContentsOpenAnimate = false;
            }, 250);
        }
    }
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    //↓↓↓↓↓カラーピッカー表示非表示↓↓↓↓↓
    //こいつはpropsでいらない
    isColorPickerVisible = false;
    showColorPicker() {
        this.isColorPickerVisible = true;
    }
    closeColorPicker() {
        this.isColorPickerVisible = false;
    }
    //↑↑↑↑↑カラーピッカー表示非表示↑↑↑↑↑

    //↓↓↓↓↓チェックボックスのアニメーション↓↓↓↓↓
    private get ratioFixed() {
        return this.layer.keepRatio == 0;
    }

    ratioFixChange() {
        // 縦横固定だった場合、内部データは縦固定にする。ただしこのアプリ内では自由変形
        // *スマホアプリとのデータ共存のため
        var newValue = this.layer.keepRatio == 0 ? 1 : 0;
        this.changeLayerProperty(newValue, "keepRatio", true);
    }

    private get noStroke() {
        return this.layer.noStroke;
    }

    switchNoStroke() {
        let newValue = !this.layer.noStroke;
        this.changeLayerProperty(newValue, "noStroke", true);
    }

    //↑↑↑↑↑チェックボックスのアニメーション↑↑↑↑↑

    //↓↓↓↓↓色↓↓↓↓↓
 

    get strokeColor() : ColorConstruct{
        return this.layer.strokeColor;
    }

    get strokeColorStyle() {
        return {
            background: this.strokeColor.hex
        };
    }

    // 色変更中
    private onChangingColor(color)
    {
        this.changeLayerProperty(color, "strokeColor", false);
    }
        // 色変更完了
    private onChangedColor(color)
    {
        this.changeLayerProperty(color, "strokeColor", true);
    }

    //↑↑↑↑↑色↑↑↑↑↑

    //*** 線幅 ***//
    private get strokeWidth() 
    {
        return this.layer.strokeWidth;
    }

    private onChangingValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, true);
    }


    private changeLayerProperty(value: any, propertyName: string, isFinish : boolean = false) {
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value,
            isFinish : isFinish
        });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
